//internal-deps
import { AnalyticsContextValue } from "@swiggy-private/analytics";
import { WALLET_CODES } from "@swiggy-private/payment-types";

//constants
import {
    CLICK_ACTIONS,
    IMPRESSION_ACTIONS,
    SCREEN_NAME,
    SCREEN_VIEW_ACTIONS,
} from "@payment-client/analytics/constants";

export const onClickDelinkCta = (
    screenName: string,
    walletCode: WALLET_CODES,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: screenName,
        action: CLICK_ACTIONS.CLICK_DELINK_WALLET,
        label: walletCode,
    });
};

export const onImpressionCurrentBalance = (
    screenName: string,
    walletCode: WALLET_CODES,
    amount: number,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: screenName,
        action: IMPRESSION_ACTIONS.IMPRESSION_CURRENT_BALANCE,
        label: amount,
        context: walletCode,
    });
};

export const onScreenViewAddMoney = (
    walletCode: WALLET_CODES,
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
): void => {
    screenViewEvent({
        category: SCREEN_NAME.ADD_MONEY,
        action: SCREEN_VIEW_ACTIONS.VIEW_ADD_MONEY_SCREEN,
        label: walletCode,
    });
};

export const onImpressionConfirmDelink = (
    walletCode: WALLET_CODES,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.ADD_MONEY,
        label: walletCode,
        action: IMPRESSION_ACTIONS.IMPRESSION_CONFIRM_DELINK,
    });
};

export const onClickConfirmDelink = (
    walletCode: WALLET_CODES,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.ADD_MONEY,
        label: walletCode,
        action: CLICK_ACTIONS.CLICK_CONFIRM_DELINK,
    });
};

export const onClickCancelDelink = (
    walletCode: WALLET_CODES,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.ADD_MONEY,
        label: walletCode,
        action: CLICK_ACTIONS.CLICK_CANCEL_DELINK,
    });
};

export const onImpressionSuccessDelink = (
    walletCode: WALLET_CODES,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.ADD_MONEY,
        label: walletCode,
        action: IMPRESSION_ACTIONS.IMPRESSION_SUCCESS_DELINK,
    });
};

export const onImpressionFaliedDelink = (
    walletCode: WALLET_CODES,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.ADD_MONEY,
        label: walletCode,
        action: IMPRESSION_ACTIONS.IMPRESSION_FAILED_DELINK,
    });
};

export const onClickTryAgainDelink = (
    walletCode: WALLET_CODES,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.ADD_MONEY,
        label: walletCode,
        action: CLICK_ACTIONS.CLICK_TRY_AGAIN_DELINK,
    });
};

export const onClickCrossDelinkFailure = (
    walletCode: WALLET_CODES,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.ADD_MONEY,
        label: walletCode,
        action: CLICK_ACTIONS.CLICK_CROSS_DELINK_FAILURE,
    });
};
